module.exports = __webpack_public_path__ + "static/media/devfolio.0135b4e8.svg";